import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import Decimal from 'decimal.js';
import { _useToasts } from "../../../common/_useToasts";
import {
  getDiscountPrice,
  getPriceBycolorSize,
  showCurrencycodeSymbol,
  numberWithCommas,
  getStock,
  roundedPrice,
  numberWithCommas2,
  getGlobalShowProductPrice,
} from '../../../helpers/product'
import { AuthContext } from "../../../common/Auth"
import { useHistory } from 'react-router-dom';
import moment from "moment";
import NotLoggedInModal from "../../../wrappers/product/NotLoggedInModal";
import * as productsAPIUtil from "../../../util/products/productsAPIUtil"

import {getCartItemTotal, productImageExt, productPath, replaceOrigin} from "../../../util/helper";
import Loader from "../../../common/Loader";
import { useThemeSettings } from "../../../layouts/state/useThemeSettings";
import { usePaymentMethodSettings } from "../../../layouts/state/usePaymentMethodSettings";
import { useThemeSettingsData } from "../../../layouts/state/useThemeSettingsData";
import { useProductSourceState } from "../../product/state/useProductSourceState";
import { useCheckoutFee } from "../../../pages/other/state/useCheckoutFee";
import { useProductPriceToShow } from "../../product/state/useProductPriceToShow";
import { connect } from "react-redux";
import { fetchArtworksCartById } from "../../../redux/actions/productActions";
import { useGetEnabledQuery } from '../../../redux/api/checkoutApi';
import { aetherApi } from "../../../redux/api/aetherApi";
import { useAppDispatch } from "../../../redux/hooks";
import { useProductDecoCharge } from "../../product/state/useProductDecoCharge";
import { useReadLocalStorage } from "usehooks-ts";

const MenuCart = ({ cartData, currency, deleteFromCart, deleteAllFromCart, clickonCartItem, cartArtworkList, currentNode, updateCartItem, closeCart, cartArtworkListById, fetchArtworksCartById,  }) => {
  let cartTotalPrice = 0
  const {
    user,
    tabName,
    settingData,
    paymentMethodsSettings,
    themeSettingsData,
    ipV4,
	userType,
    usePointsAsCurrency,
    storeDetails,
    userGroupDiscount,
  } = useContext(AuthContext)
  const [cartProducts, setCartProducts] = useState(cartData)
  const [inventoryStock, setInventoryStock] = useState([])
  const [dtsInventoryStock, setDtsInventoryStock] = useState([])
  const [isInventoryStock, setIsInventoryStock] = useState(true)
  const [isInventoryShow, setIsInventoryShow] = useState(false)
  const [isCheckBtnDsb, setIsCheckBtnDsb] = useState(false)
  const [openModel, setOpenModel] = useState(false)
  const [productsWithOutStock, setProductsWithOutStock] = useState([]);
  const [loader, setLoader] = useState(false)
  const [moqCartErrors, setMoqCartErrors] = useState([])
  const [quantityCartErrors, setQuantityCartErrors] = useState([])
  const [decimalsToShow, setDecimalsToShow] = useState(2);
  const [containerStyle, setContainerStyle] = useState({top:(currentNode.top + 30), left:(currentNode.left)});
  const [decorationsInCart, setDecorationsInCart] = useState([]);
  const { _addToast } = _useToasts()
  const history = useHistory()
  const [invalidQtysInCart, setInvalidQtysInCart] = useState(false)
  const dispatch = useAppDispatch()
  const {
    priceDisplay,
    itempriceDisplay,
    requireRegistration,
    daysTopurgeCartitem,
    isPublic,
    registrationRequired,
    checkoutSettings,
    productCommentInCartRequired,
    productCommentInCartLabel
  } = useThemeSettings({ settingData })

  const {
    isStock,
    productSettings,
    isLPublic,
    registrationLCheckoutRequired,
    isAllowoutofStockOrder
  } = useThemeSettingsData({ themeSettingsData })

  const {
    getPointsValue
  } = useProductPriceToShow({ productSettings  })

  const { setItemSource } = useProductSourceState({
    dtsInventoryStock, cartProducts, isStock, inventoryStock
  })

  const {
    isPaymentEnabled,
    isQuoteEnabled
  } = usePaymentMethodSettings({ paymentMethodsSettings })

  const {
    getDecoPriceByQuantity,
    getDecoChargesByQuantity,
    getAdditionalDecorationCharge
  } = useProductDecoCharge({ artworksFromState: cartArtworkList })


  const {
    moqErrors,
    quantityErrors,
    getQuantityProduct,
    getOthersQuantity,
  } = useCheckoutFee({
    cartItems: cartData,
    validateInventory: true,
    isAllowoutofStockOrder,
  })

  const punchOutSession = useReadLocalStorage('punch-out-session', { deserializer: (value) => value || '' });
  const { data: newCheckoutEnabled, isLoading: checkoutEnabledLoading } = useGetEnabledQuery()

  const hideDelete = useMemo(() => history?.location?.pathname?.includes("newcheckout"), [history])

  useEffect(() => {
    setMoqCartErrors(moqErrors)
  }, [moqErrors])
  
  useEffect(() => {
    setQuantityCartErrors(quantityErrors)
  }, [quantityErrors])
  
  let showPrice = false
  if (user) {
    if (itempriceDisplay !== false) {
      showPrice = true
    }
  } else {
    if (priceDisplay !== false) {
      showPrice = true
    }
  }

  let requireLogin = false
  const IsPublicData = isLPublic !== undefined ? isLPublic : isPublic ?? true
  const isRegistrationCheckoutRequired = registrationLCheckoutRequired !== undefined ? registrationLCheckoutRequired :  registrationRequired ?? false
  if(!IsPublicData && isRegistrationCheckoutRequired) {
    requireLogin = isRegistrationCheckoutRequired
  }

  useEffect(() => {
    setIsCheckBtnDsb(true)
    let componentMounted = true
	if(cartData){
		setCartProducts(cartData);
  }
    if(cartData?.length && isStock !== "") {
      fetchData()
    }
    return () => {
      componentMounted = false
    }
  }, [cartData, isStock])
  useEffect(() => {
    setInvalidQtysInCart(false);
    if(cartData && cartData.length && decorationsInCart.length === 0) {
      const decorations = []
      cartData.map((itemArray) => {
        (itemArray.currentOrder || []).map((currentOrder) => {
          currentOrder.map((orderRow) => {
            if(orderRow.quantity === '' || orderRow.quantity === '0') {
              setInvalidQtysInCart(true);
            }
            (orderRow.decorations || []).map((deco) => {
              decorations.push(deco)
            })
          })
        })
      })
      if(decorations.length) {
        setDecorationsInCart(decorations)
      }
    }
  }, [cartData])
  
  useEffect(() => {
    if (decorationsInCart && decorationsInCart.length > 0) {
      if (storeDetails && storeDetails.accountId) {
        setLoader(true)
        fetchArtworksCartById({
            account_id: storeDetails.accountId,
            ids: decorationsInCart.map(x => x.artworkID),
            products: cartData.map(item => item.product.id)
        }).finally(() => {
          setLoader(false)
        })
      }
    }
  }, [storeDetails, decorationsInCart])

  useEffect(() => {
    verifyStock();
  }, [inventoryStock, dtsInventoryStock])
  
  useEffect(() => {
    if(!!productSettings?.decimalsToShow) {
      setDecimalsToShow(Number(productSettings.decimalsToShow))
    }
  }, [productSettings])

  const fetchData = async ()=>{
    setLoader(true)
    let promises = []
    let products = []
    cartData.map(async (item)=>{
      if(products.findIndex(x => x === item.product.id) === -1) {
        promises.push(productsAPIUtil.getProductStock(item.product.id));
        products.push(item.product.id);
      }
    })
    let stockTempArray = []
    let inventoryArrayDatatemp = [];
    let dstInventoryArrayDataTemp = [];
    let productInventoryArray = []
    Promise.all(promises)
        .then((data)=>{
          setLoader(false)
          if ( data && data.length > 0 ) {
            data.map((res)=>{
              if ( res && res.data ) {
                /*
                Product inventory
                */
                let productInventory = res.data.inventory
                productInventoryArray.push(productInventory)
                let productItem = cartData.filter(
                    (itemFilter)=>
                        itemFilter.product.productId ===
                        productInventory.productId,
                )[0]
                if ( productInventory && productItem?.product ) {
                  if (
                      productInventory.productId ===
                      productItem.product.productId
                  ) {
                    inventoryArrayDatatemp[productItem.product.productId] =
                        productInventory.PartInventoryArray?.PartInventory
                  }
                }
                // dstInventory
                if (res.data.dtsInventory?.data?.length) {
                  dstInventoryArrayDataTemp.push(res.data.dtsInventory?.data)
                }
              }
            })
            setIsCheckBtnDsb(false)
            setInventoryStock(productInventoryArray)
            setDtsInventoryStock(dstInventoryArrayDataTemp)
            setIsInventoryShow(true)
          }

        })
        .catch((error)=>{
          setLoader(false)
          setIsCheckBtnDsb(false)
          console.log('error', error)
        })
  }

  const verifyStock = () => {
    let productAllowOutOfStock = [];
    let IsAllowOutOfStockOrder = false;
    cartProducts && cartProducts.length > 0 && cartProducts.map(async(cardProduct, key) => {
      if(cardProduct?.product?.AllowOutofStock === false)
      {
        if(!productAllowOutOfStock.includes(cardProduct?.product?.id))
          productAllowOutOfStock.push(cardProduct?.product?.id)
      }
    })
    if(productAllowOutOfStock.length > 0)
      IsAllowOutOfStockOrder = false
    else if(isAllowoutofStockOrder === true)
      IsAllowOutOfStockOrder = true

    if (IsAllowOutOfStockOrder) {
      setIsInventoryStock(true);
      setProductsWithOutStock([]);
    } else {
      if(inventoryStock){
        let productWithOutStock = [];
        cartProducts.length > 0 && cartProducts.map(async(cardProduct, key) => {
          let productWithOutStock = [];
          let dtsInventoryProduct = [];
          (dtsInventoryStock || []).forEach(dtsInventoryArray => {
            (dtsInventoryArray || []).forEach(dtsInventory => {
              if (dtsInventory.productId === cardProduct?.product?.productId) {
                dtsInventoryProduct.push(dtsInventory);
              }
            })
          })
          const itemProductId = cardProduct.product?.productId
          const productId = cardProduct?.product?.id
          const isStockFor = !!!cardProduct.product?.isStockFor || cardProduct.product.isStockFor === 'globalsetting' ? isStock : cardProduct.product.isStockFor
          const isAllowOutOfStockOrder = typeof cardProduct.product?.AllowOutofStock === 'boolean'
              ? cardProduct.product?.AllowOutofStock : isAllowoutofStockOrder;
          cardProduct.currentOrder.forEach(currentOrder => {
            currentOrder.forEach(product => {
              const stockData = getStock(product.size, product.color,
                  inventoryStock.find(x => productId === x.id?.toString()) || {},
                  cardProduct?.product,
                  dtsInventoryProduct,
                  isStockFor);
              const quantityInCart = getOthersQuantity(product.size, product.color, itemProductId, Number(product.quantity));
              if(!isAllowOutOfStockOrder && (Number(product.quantity) > (stockData - quantityInCart))){
                let productStock = {...product, stockData: stockData, productId: itemProductId}
                productWithOutStock.push(productStock);
              }
            })
          })
        });
        if(productWithOutStock.length > 0 && IsAllowOutOfStockOrder === false) {
          setIsInventoryStock(false);
          setProductsWithOutStock(productWithOutStock);
        } else {
          setIsInventoryStock(true);
          setProductsWithOutStock([]);
        }
      }
    }
  }

  const addToTotalPrice = (ItemTotalPrice, orderRow, decosalePrice) => {
    // orderRow?.decorations && orderRow.decorations.map((decoitemArray, index) => {
    //   if (decoitemArray?.decoPricedetails) {
    //     decosalePrice = decosalePrice + Number(decoitemArray.decoPricedetails.salePrice)
    //   }
    // })
    let tPrice = ItemTotalPrice
    tPrice =
      Number(tPrice) +
      Number(
        Number(orderRow.quantity) *
          (Number(orderRow.price) + Number(decosalePrice)),
      )
    return tPrice.toFixed(decimalsToShow)
  }
  const navigateTO = (product) => {
    localStorage.removeItem('catTree')
    history.push(`/product/` + productPath(product))
  }


  useEffect(() => {
    if (daysTopurgeCartitem && Number(daysTopurgeCartitem) > 0) {
      if (cartData && cartData.length > 0) {
        for (let key = cartData.length - 1; key >= 0; key--) {
          let single = cartData[key];
          if (single.dateTime) {
            var end = moment(single.dateTime)
            var start = moment()
            let daysdiff = moment.duration(start.diff(end)).asDays()
            if (daysdiff > daysTopurgeCartitem) {
              deleteFromCart(single.product, false,single.product?.isPriceBreak?(single?.product?.doNotCalculateAtOrder == "1" ?
                 false : true):false,key,0, ipV4, userGroupDiscount)
            }
          } else if (single.dateTime === undefined) {
            deleteFromCart(single.product, false,false, key, 0, ipV4, userGroupDiscount);
          }
        }
      }
    }
  }, [daysTopurgeCartitem]);

  const handleCancel = () => {
    setOpenModel(false)
  }

  const proceedCheckout = () => {
    closeCart()
    if (!user) {
      setOpenModel(true)
    } else {
      proceedCheckout2()
    }
  }

  const addRequiredCommentToast = () => {
    _addToast(productCommentInCartLabel + " is required", {
      appearance: "error",
      autoDismiss: true
    });
    history.push(process.env.PUBLIC_URL + '/cart')
  };

  const proceedCheckout2 = () => {
    closeCart()
    let productAllowOutOfStock = [];
    let RequiredDecorationForCheckOutPro = [];
    cartProducts && cartProducts.length > 0 && cartProducts.map(async(cardProduct, key) => {
      let IsAllowOutOfStockOrder = false;
      if(cardProduct?.product?.AllowOutofStock === false || cardProduct?.product?.AllowOutofStock === true) {
        IsAllowOutOfStockOrder = cardProduct?.product?.AllowOutofStock;
      } else {
        IsAllowOutOfStockOrder = isAllowoutofStockOrder;
      }
      if (!IsAllowOutOfStockOrder) {
        const productWithOutStock = productsWithOutStock.find(product => product.productId === cardProduct?.product?.id)
        if (!productAllowOutOfStock.includes(cardProduct?.product?.id) && productWithOutStock && !isInventoryStock)
          productAllowOutOfStock.push(cardProduct?.product?.id)
      }
      if(cardProduct.currentOrder.length > 0) {
        cardProduct.currentOrder.map((res) => {
          if(res?.[0]?.decorations && !res?.[0]?.decorations.length > 0 && (cardProduct?.product?.RequiredDecorationForCheckOutPro === true || productSettings?.RequiredDecorationForCheckOut === true)) {
            if(cardProduct?.product?.RequiredDecorationForCheckOutPro === true)
              return RequiredDecorationForCheckOutPro.push(cardProduct?.product?.id)
            if(productSettings?.RequiredDecorationForCheckOut === true && cardProduct?.product?.RequiredDecorationForCheckOutPro !== true && cardProduct?.product?.RequiredDecorationForCheckOutPro !== false)
              return RequiredDecorationForCheckOutPro.push(cardProduct?.product?.id)
          }
        })
      }
    })
    if ( productAllowOutOfStock.length > 0 && !(RequiredDecorationForCheckOutPro.length > 0) ) {
      setItemSource()
      if (newCheckoutEnabled) {
        goToNewCheckout()
      } else {
        history.push(process.env.PUBLIC_URL + '/checkout')
      }
    } else {
      if ( !isInventoryStock ) {
        _addToast('Some of the products in your cart are out of stock, please select other products', {
          appearance: "warning",
          autoDismiss: true
        })
      } else if ( RequiredDecorationForCheckOutPro.length > 0 ) {
        _addToast('Some products require decoration for checkout, please include product with decoration.', {
          appearance: "warning",
          autoDismiss: true
        })
      } else if ( moqCartErrors.length > 0 ) {
        moqCartErrors.forEach(moqError=>{
          _addToast(moqError, {
            appearance: "warning",
            autoDismiss: true
          })
        })
      } else if ( quantityCartErrors.length > 0 ) {
        quantityCartErrors.forEach(quantityError=>{
          _addToast(quantityError, {
            appearance: "warning",
            autoDismiss: true
          })
        })
      } else {
        setItemSource()
        if (newCheckoutEnabled) {
          goToNewCheckout()
        } else if(productCommentInCartRequired){
          addRequiredCommentToast()
        }
          else {
          history.push(process.env.PUBLIC_URL + '/checkout')
        }
      }
    }

  }

  const goToNewCheckout = async () => {
    if(productCommentInCartRequired){
      addRequiredCommentToast()
    } else {
      if (punchOutSession) {
        history.push(process.env.PUBLIC_URL + '/punchout')
      } else {
        history.push(process.env.PUBLIC_URL + '/newcheckout');
        dispatch(aetherApi.util.invalidateTags(["CheckoutSession"]));
      }
    }
  }

  let flag = true

  return (
    <div className={`shopping-cart-content active`} style={containerStyle}>
      {(loader || checkoutEnabledLoading) && <Loader />}
      {flag && cartProducts && cartProducts.length > 0 ? (
        <Fragment>
          <ul>
            {cartProducts.map((single, key) => {
              flag = false
              const discountedPrice = null
              let itemTotalPrice = 0
              let totalDecoPrice = 0
              let totalSetupPrice = 0
			  let totalDecoCost=0 
			  let artwork
              let dtsInventoryProduct = [];
              let showSetupCharges = false
              let setupCharges = [];
              const productId = single?.product?.id
              let decimalsToShowProduct = 2;
              if(!!single?.product?.decimalsToShow) {
                decimalsToShowProduct = Number(single?.product?.decimalsToShow, decimalsToShowProduct)
              } else {
                decimalsToShowProduct = Number(decimalsToShow);
              }
              if(typeof single?.product?.showSetupChargeInCart === 'boolean') {
                showSetupCharges = single?.product?.showSetupChargeInCart
              } else {
                showSetupCharges = productSettings['showSetupChargeInCart']
              }
              if(showSetupCharges) {
                let quantity = getQuantityProduct(single?.currentOrder);
                if(single?.product?.ChargeArray?.Charge?.length > 0) {
                  single.product.ChargeArray.Charge.forEach(charge => {
                    if(setupCharges.findIndex(x => x.chargeCode === charge.chargeCode) === -1) {
                      const chargeByQuantity = charge?.ChargePriceArray?.ChargePrice?.filter(x => Number(x.xMinQty) <= quantity)
                      if(chargeByQuantity.length > 0) {
                        let totalSetupPriceUnit = (Number(chargeByQuantity?.[chargeByQuantity.length - 1]?.salePrice) ?? 0) * (charge?.matchOrderQty === "1" ? quantity : 1);
                        totalSetupPrice += totalSetupPriceUnit;
                        setupCharges.push({totalSetupPrice: totalSetupPriceUnit, chargeCode: charge.chargeCode});
                      }
                    }
                  })
                }
              }
              let cnt = 0;
              let totalSumqw = 0
              let totalSumQty = 0
              single.currentOrder.map((itemsRowsabs, keya) => { itemsRowsabs && itemsRowsabs.length > 0 && itemsRowsabs.map((sizeObj, index) => {
                  if(!!sizeObj?.personalization) {
                    totalSumqw = totalSumqw + Number(sizeObj?.quantity && sizeObj?.quantity)
                  }
                  totalSumQty = totalSumQty + Number(sizeObj?.quantity && sizeObj?.quantity)
                })
              })
              single.currentOrder.map((itemsRowsabs, keya) => {
                  if(!!itemsRowsabs[0] && itemsRowsabs[0]?.personalization) {
                    cnt = cnt + 1;
                  }
              })
              dtsInventoryStock.forEach(dtsInventoryArray => {
                dtsInventoryArray.forEach(dtsInventory => {
                  if(dtsInventory.productId === single?.product?.productId) {
                    dtsInventoryProduct.push(dtsInventory);
                  }
                })
              })
              let withoutStockList = []
              const itemProductId = single?.product?.productId
              const isStockFor = !!!single.product?.isStockFor || single.product.isStockFor === 'globalsetting' ? isStock : single.product.isStockFor
              single.currentOrder.forEach(orderData => {
                orderData.forEach(product => {
                  const stockData = getStock(product.size, product.color,
                      inventoryStock.find(x => productId === x.id?.toString()) || {},
                      single?.product,
                      dtsInventoryProduct,
                      isStockFor);
                  const quantityInCart = getOthersQuantity(product.size, product.color, itemProductId, Number(product.quantity));
                  if(Number(product.quantity) > (stockData - quantityInCart)) {
                    withoutStockList.push({...product, stockData});
                  }
                })
              })
			  let customDecorationFee =single?.product?.customDecorationFee
        let showDecoration = null
        if(single?.product?.showDecoration === true || single?.product?.showDecoration === false) {
          showDecoration = single?.product?.showDecoration
        } else {
          showDecoration = productSettings['showDecoration'];
        }
			  let customDecorationPerUnitPrice =single?.product?.customDecorationPerUnitPrice
			  let customDecorationSetupFee =single?.product?.customDecorationSetupFee
			  let allowCustomDecoration = false
			  if(single?.product?.allowCustomDecoration === true || single?.product?.allowCustomDecoration === false) {
			   allowCustomDecoration = single?.product?.allowCustomDecoration
			  } else {
          allowCustomDecoration = !!productSettings?.allowCustomDecoration ? productSettings.allowCustomDecoration : false
			  }
        let disIndProductPrice = getGlobalShowProductPrice(single?.product, itempriceDisplay, priceDisplay, user );
        let showItemPricetd = showPrice
        let productFromSettings = single?.currentOrder?.[0]?.[0];
        let isPriceBreak = single?.product?.isPriceBreak ? (single?.product?.doNotCalculateAtOrder == "1" ? false : true) : false
        if(disIndProductPrice === false || disIndProductPrice === true){
          showItemPricetd = disIndProductPrice
        }
        if (single?.isKitChildProduct && single?.kitPriceMode !== "separate") {
          showItemPricetd = false;
        }
        let kitTotalPrice = 0;
        let showKitSubtotal = false;
        if (single?.product?.isKitEnabled && single?.product?.kitPriceMode === "rollup" && disIndProductPrice) {
          const kitItems = cartProducts.filter((item) => item.product.kitId === single?.product?.kitId);
          kitTotalPrice = kitItems.reduce((current, value) => current + Number(getCartItemTotal(value, cartArtworkList, productSettings, 0, false, user, itempriceDisplay, priceDisplay)), Number(0));
          showKitSubtotal = true;
          cartTotalPrice += kitTotalPrice;
          showItemPricetd = false;
        }
			  let productImage = single.currentOrder.length > 0 ? single.product.MediaContent.filter(
                (val) => val.color == single.currentOrder[0][0].color,
              ) : [];
              if (single.currentOrder && single.currentOrder.length > 0) {
                single.currentOrder.map((orderRow) => {

                  let decoPriceFlag = true
                  orderRow.length > 0 &&
                    orderRow.map((rowArray, rowArrayIndex) => {
                      let decosalePrice = 0
                      const additionalCharges = []
                      let totalAdditionalCharges = 0
                      let artwork=null

                      let decoChargeArray = []
                      if ( Number(rowArray.quantity) > 0 ) {
                        decoChargeArray = getDecoChargesByQuantity(
                            rowArray?.decorations,
                            isPriceBreak ? totalSumQty : rowArray.quantity,
                            productId
                        )
                        if ( cartArtworkList?.length ) {
                          let quantityForDecoration = 0;
                          quantityForDecoration += Number(rowArray.quantity);
                          rowArray && showDecoration && rowArray.decorations && rowArray.decorations.map((decoArray, index)=>{
                            artwork = cartArtworkList.find(
                                (artworkArray)=>(artworkArray.id === decoArray.artworkID),
                            )
                            if (rowArrayIndex === 0) {
                              const additionalChargeData = getAdditionalDecorationCharge(
                                artwork || {},
                                quantityForDecoration,
                                decoArray.locationId,
                                single.product?.id
                              );
                              totalAdditionalCharges += additionalChargeData.totalAdditionalCharges;
                              additionalCharges.push(...additionalChargeData.additionalCharges);
                            }
                            if ( artwork?.artworkSource == 'aether' && showDecoration && customDecorationFee && allowCustomDecoration && decoPriceFlag ) {
                              decoPriceFlag = false;
                              if ( showSetupCharges ) {
                                itemTotalPrice = itemTotalPrice + (customDecorationSetupFee ? Number(customDecorationSetupFee) : Number(0))
                                itemTotalPrice = (new Decimal(itemTotalPrice).toDP(decimalsToShowProduct)).toNumber();
                              }
                            } else {
                              if ( decoChargeArray?.length > 0 && decoPriceFlag ) {
                                decoPriceFlag = false;
                                if ( showSetupCharges ) {
                                  decoChargeArray.forEach(decoArrayValue=>{
                                    itemTotalPrice = Number(itemTotalPrice) + (decoArrayValue.setupChargeSalePrice ? Number(decoArrayValue.setupChargeSalePrice) : Number(0));
                                    itemTotalPrice = (new Decimal(itemTotalPrice).toDP(decimalsToShowProduct)).toNumber();
                                  })
                                }
                              }
                            }
                            if ( artwork?.artworkSource == 'aether' && showDecoration && customDecorationFee && allowCustomDecoration ) {
                              decosalePrice = Number(customDecorationPerUnitPrice ?? 0)
                            } else {
                              decosalePrice = getDecoPriceByQuantity(
                                  rowArray?.decorations,
                                  isPriceBreak ? totalSumQty : rowArray.quantity,
                                  productId
                              )

                            }
                            if ( artwork?.artworkSource == 'aether' && showDecoration && customDecorationFee && allowCustomDecoration ) {
                              if ( rowArray?.decorations?.length > 0 ) {
                                totalDecoCost = (customDecorationPerUnitPrice ?? 0) * rowArray.quantity
                              }
                            } else {
                              totalDecoCost = decosalePrice * rowArray.quantity
                            }
                          })
                          if(showSetupCharges) {
                            additionalCharges.forEach(additionalCharge => {
                              if (additionalCharge?.totalSetupCharge) {
                                setupCharges.push(additionalCharge)
                              }
                            })
                            totalSetupPrice += totalAdditionalCharges
                          }
                        }

                      }

                      let persolizationCostData = rowArray.personalizationCost
                      let personalizationCost = 0

                      if (persolizationCostData?.price > 0 || persolizationCostData?.setupPrice > 0) {
                        if (persolizationCostData?.matchOrderQty == 0) {
                          personalizationCost = Number(
                            persolizationCostData?.price,
                          )+Number(showSetupCharges ? persolizationCostData.setupPrice : 0)
                        } else if (persolizationCostData?.matchOrderQty == 1) {
                          personalizationCost =
                            (Number(persolizationCostData?.price) *
                            Number(totalSumqw))+(Number(showSetupCharges ?
								persolizationCostData.setupPrice : 0,
							  ) * Number(cnt))
                        }
                      }
                      let mainPrice = Number(rowArray.quantity) * Number(Number(rowArray.price).toFixed(decimalsToShowProduct))
                      if (single?.product?.doNotCalculateAtOrder == "1" && single?.product?.isRestrictQty) {
                        mainPrice = Number(rowArray.price).toFixed(decimalsToShowProduct)
                      }
                      let totalCharges = 0
                      itemTotalPrice =
                        Number(itemTotalPrice) +
                        Number(totalDecoCost) +
                        Number(personalizationCost) +
                        Number(totalCharges) +
                        Number(mainPrice)

                    })
                    if(showSetupCharges) {
                      itemTotalPrice = Number(itemTotalPrice) + Number(totalSetupPrice);
                      itemTotalPrice = (new Decimal(itemTotalPrice).toDP(decimalsToShowProduct)).toNumber();
                    }
                })
              }
              if(showItemPricetd) {
                cartTotalPrice = Number(cartTotalPrice) + Number(itemTotalPrice)
                cartTotalPrice = (new Decimal(cartTotalPrice).toDP(decimalsToShowProduct)).toNumber();
              }
              let image =
                single &&
                single.product &&
                single.product.MediaContent &&
                single.product.MediaContent[0] &&
                single.product.MediaContent[0].url
              if (productImage.length > 0 && productImage[0]?.url) {
                image = productImage[0].url
              }
              if(single?.product?.isPrintable && single.product.printValues?.images?.length) {
                image = single.product.printValues?.images[0]
              }
              let IsAllowOutOfStockOrder = single.product?.AllowOutofStock;
              IsAllowOutOfStockOrder = IsAllowOutOfStockOrder === undefined ? isAllowoutofStockOrder : IsAllowOutOfStockOrder && true
              let imgClass = 'img-fluid'
               if( single?.product?.printValues) {
                imgClass += ' temp-print'
              }
              return (
                <li className="single-shopping-cart" key={key}>
                  <div className={`${!!image && productImageExt(image) ? 'product-img-bg' : '' } shopping-cart-img`}>
                    <img
                      alt=""
                      src={replaceOrigin(image)}
                      className={imgClass}
                      onClick={() => {
                        navigateTO(single.product)
                        clickonCartItem()
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <div className="shopping-cart-title">
                    <h4
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        navigateTO(single.product)
                        clickonCartItem()
                      }}
                    >
                      {' '}
                      {single.product.productName}{' '}
                    </h4>
                    <div
                      className="cartqty row"
                      style={{ borderBottom: '1px solid lightgray' }}
                    >
                      <div className="col-md">
                        {' '}
                        {single.currentOrder &&
                          single.currentOrder.length > 0 &&
                          single.currentOrder.map((orderRow, key) => {

                            let showColorProd = single.product.showColorProd || productSettings?.showColor
                            let showSizeProd = single.product.showSizeProd
                            let colorLabel = 'Color'
                            if(!!single?.product?.relabelColor) {
                              colorLabel = single.product.relabelColor
                            }
                            return (
                              <div key={key}>
                                {orderRow.length > 0 &&
                                  orderRow.map((rowArray, rowkey) => {
                                    return (
                                      <div>
                                        {(!single.product.isKitEnabled || !single.product.kitChangeQuantity) &&
                                        <div className="cart-item-variation">
                                          <span>
                                            Quantity: {rowArray.quantity}
                                          </span>
                                        </div>
                                        }
                                        {showSizeProd && rowArray.size && (
                                          <div className="cart-item-variation mt-0">
                                            <span key={key + '_' + rowkey}>
                                              {'Size'}: {rowArray.size}
                                            </span>
                                          </div>
                                        )}
                                        {showColorProd && rowArray['color'] && (
                                          <div className="cart-item-variation mt-0">
                                            <span>
                                              {colorLabel}: {rowArray['color']}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    )
                                  })}
                              </div>
                            )
                          })}
                      </div>
                    </div>

                    {(showItemPricetd) && (
                      <span>
                        {
                          usePointsAsCurrency ? getPointsValue(Number(itemTotalPrice)) : <>
                            {Number(itemTotalPrice) !== 0 &&
                                currency.currencySymbol +
                                (productSettings?.priceRoundUp ?  numberWithCommas2(roundedPrice(Number(itemTotalPrice)), decimalsToShowProduct) : numberWithCommas2(Number(itemTotalPrice), decimalsToShowProduct))}
                          </>
                        }
                      </span>
                    )}
                    {(showKitSubtotal) && (
                      <span>
                        {
                          usePointsAsCurrency ? getPointsValue(Number(kitTotalPrice)) : <>
                            {Number(kitTotalPrice) !== 0 &&
                                currency.currencySymbol +
                                (productSettings?.priceRoundUp ?  numberWithCommas2(roundedPrice(Number(kitTotalPrice)), decimalsToShowProduct) : numberWithCommas2(Number(kitTotalPrice), decimalsToShowProduct))}
                          </>
                        }
                      </span>
                    )}
                    { isInventoryShow && !IsAllowOutOfStockOrder &&
                      withoutStockList.length > 0 && 
                      <>
                        <p style={{ color: "red" }}>Out of Stock
                        {withoutStockList.map(item => {
                          return (
                          <>
                            <br/><span style={{color:"#9b9b9b"}}>Available Inventory {item.color}-{item.size}: {item.stockData}</span>
                          </>
                          )
                        })}
                        </p>
                      </>
                    }
                  </div>
                  <div className="shopping-cart-delete">
                    {!hideDelete && !single.isKitChildProduct &&
                      <button
                        onClick={() => {
                          deleteFromCart(single.product, _addToast, single.product?.isPriceBreak ? (single?.product?.doNotCalculateAtOrder == '1' ? false : true) : false, key, 0, userGroupDiscount)
                          verifyStock()
                        }}
                      >
                        <i className="fa fa-times-circle" />
                      </button>
                    }
                  </div>
                </li>
              )
            })}
          </ul>
          {showPrice && (
            <div className="shopping-cart-total">
              <h4>
                Total :{' '}
                <span className="shop-total">
                 {
                   usePointsAsCurrency ? getPointsValue(Number(cartTotalPrice)) : <>
                     {currency.currencySymbol}
                     {productSettings?.priceRoundUp ?  numberWithCommas2(roundedPrice(Number(cartTotalPrice)), decimalsToShow) : numberWithCommas2(Number(cartTotalPrice), decimalsToShow)}
                   </>
                 }
                </span>
              </h4>
            </div>
          )}
          <div className="shopping-cart-btn btn-hover text-center">
            <Link
              data-testid="view-cart-button-plw"
              className="default-btn"
              to={process.env.PUBLIC_URL + '/cart'}
              onClick={() => {
                clickonCartItem()
                setItemSource()
              }}
            >
              view cart
            </Link>
            {/* {isPaymentEnabled && <Link
              className="default-btn"
              to={process.env.PUBLIC_URL + "/checkout"}
            >
              checkout
            </Link>} */}
            {!requireLogin
              ? (isPaymentEnabled || isQuoteEnabled) && (
                  <button disabled={isCheckBtnDsb || invalidQtysInCart} onClick={() => proceedCheckout2()}
                    className="default-btn"
                    data-testid="checkout-button-plw"
                  >
                   {(checkoutSettings?.checkoutQuickviewRename) ? (checkoutSettings?.checkoutQuickviewRename) : 'Checkout'}
                  </button>
                )
              : (isPaymentEnabled || isQuoteEnabled) && (
                  <button
                  disabled={isCheckBtnDsb || invalidQtysInCart}
                    className="default-btn"
                    onClick={() => proceedCheckout()}
                  >
                    <span  className="default-btn" > {(checkoutSettings?.checkoutQuickviewRename) ? (checkoutSettings?.checkoutQuickviewRename) : 'Checkout'}  </span>
                  </button>
              )}
            {invalidQtysInCart &&
              <label className={'error'}> Product quantities must be greater than 0 </label>
            }
            {openModel && (
              <NotLoggedInModal
                openM={openModel}
                cancel={() => handleCancel()}
              />
            )}
            {!(isPaymentEnabled || isQuoteEnabled) && (
              <Link
                to={'#'}
                className="default-btn"
                style={{ backgroundColor: '#ebebeb', color: '#FF7F00' }}
                onClick={clickonCartItem}
              >
                Unable to proceed to checkout
              </Link>
            )}
            <span>
              {!(isPaymentEnabled || isQuoteEnabled) && (
                <small>
                  * Please contact your administrator to enable a payment
                  method.
                </small>
              )}
            </span>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">No items added to cart</p>
      )}
    </div>
  )
};

MenuCart.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  deleteFromCart: PropTypes.func,
  isVisibleCart: PropTypes.bool,
  clickonCartItem: PropTypes.func
};
const mapStateToProps = state => {
  return {
    cartArtworkList: state.productData.cartArtworkList,
    cartArtworkListById: state.productData.cartArtworkListById
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchArtworksCartById: (filterData) => dispatch(fetchArtworksCartById(filterData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuCart)
